<template>
  <v-app>
    <impersonation-banner />
    <core-loader />
    <router-view :key="$route.path" />
    <modal-container />
  </v-app>
</template>

<script>

  import ModalContainer from '@/core/components/dialogs/ModalContainer'
  import CoreLoader from '@/core/components/Loader'
  import ImpersonationBanner from "@/core/components/ImpersonationBanner.vue";

  export default {
    name: 'App',
    components: {
      ImpersonationBanner,
      ModalContainer,
      CoreLoader,
    },
  }
</script>
